import { LoanCriteria } from '@nemuru-eng/js-api-client';

import { getApplicationTypes } from '@/utils/getApplicationTypes';

export const getApplicationTypeByLoanCriteria = (loan: LoanCriteria) => {
  const applicationTypes = getApplicationTypes({
    assetTypes: [loan.assetType],
    onboardingFulfilledBys: [loan.onboardingFulfilledBy],
  });
  return applicationTypes[0];
};
